import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { TripTypePropDefault, TripType } from '../../models/TripType';
import { setTripType } from '../../redux/currentSearch/actions';
import { getTripType } from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { EntryPoint } from '../../models/EntryPoint';

const TripTypeSelector = React.memo(({ render, trackEvent, pageCategory = 'home' }) => {
    const dispatch = useDispatch();
    const value = useSelector((state) => getTripType(state)) || TripTypePropDefault;
    const activeProduct = useSelector((state) => state.activeProduct.activeProduct);


    const onTripTypeChange = (newValue) => {
        dispatch(setTripType(newValue));

        const isFlight = activeProduct === EntryPoint.FLIGHTS;
        const typeCode = newValue === TripType.ROUND_TRIP ? 'RT' : 'OW';

        trackEvent({
            category: pageCategory,
            action: isFlight ? 'searcher_flights' : 'searcher_trains',
            label: `triptype_button_click:${typeCode}`
        });
    };
    return render(value, onTripTypeChange);
});

TripTypeSelector.propTypes = {
    render: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const TripTypeSelectorWithPageContext = withPageContext(TripTypeSelector);
export { TripTypeSelectorWithPageContext as TripTypeSelector };
